<template>
  <div class="w-100">
    <div class="position-relative z-index-1045">
      <div class="row no-gutters justify-content-center">
        <div class="position-fixed w-100 d-block nav-bottom" style="bottom:0;">
          <div class="custom-container-fluid px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                <div class="bg-white rounded-top-6">
                  <div class="w-100">
                    <div class="container p-4">
                      <div class="w-100">
                        <div class="row">
                          <div class="col-9 align-self-center">
                            <p class="mb-0 body-2-2 font-bold text-18">{{data.name}}</p>
                          </div>
                          <div class="col-3 text-right align-self-center">
                            <img src="../../../../assets/img/icon/close.png" width="16" class="cursor-pointer" @click="done">
                          </div>
                        </div>
                      </div>
                      <div class="pb-2 pt-3 my-3 border-top border-bottom">
                        <p class="mb-2 body-3-3 text-16 font-bold">{{$t('hotel.action.choose-variant')}}</p>
                        <div class="row slim-grid-row">
                          <div class="col-6" v-for="(variant, index) in data.variant_list">
                            <div class="text-center w-100 cursor-pointer" @click="variant_selected = variant">
                              <div class="border_1 py-1 px-3 cursor-pointer bg-light-page mr-2 rounded-3" :class="{'delay bg-orange border-orange': variant_selected.product_ga_pos_id == variant.product_ga_pos_id}">
                                <p class="body-2 mb-0 text-unactive text-14 font-semibold" :class="{'font-bold text-white':variant_selected.product_ga_pos_id == variant.product_ga_pos_id}">{{variant.name}}</p>
                                <p v-if="is_decrease_promo(variant.price)" class="body-2 mb-0 text-12 text-orange text-line-through" :class="{'font-bold text-white':variant_selected.product_ga_pos_id == variant.product_ga_pos_id}">{{formatCurrency(promotion_price(variant.price))}}</p>
                                <p class="body-2 mb-0 text-12 text-orange" :class="{'font-bold text-white':variant_selected.product_ga_pos_id == variant.product_ga_pos_id}">{{formatCurrency(final_price(variant.price))}}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="height-75px"></div>
                      <div class="position-relative" style="z-index: 1037">
                        <div class="row no-gutters justify-content-center">
                          <div class="fixed-bottom d-block nav-bottom" style="bottom:-10px">
                            <div class="custom-container-fluid px-0">
                              <div class="row justify-content-center no-gutters">
                                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                                  <div class="container px-4 pt-2 bg-white height-75px box-shadow-top">
                                    <div class="row justify-content-center slim-grid-row">
                                      <div class="col-4">
                                        <div type="button" class="button-secondary bg-white w-100" style="cursor:auto;">
                                          <img src="../../../../assets/img/icon/minus-orange.png" width="15" class="d-inline-block cursor-pointer" @click="changeQtyProduct('minus')">
                                          <p class="mb-0 body-3-3-2 text-14 d-inline-block mx-2">{{counter}}</p>
                                          <img src="../../../../assets/img/icon/plus-orange.png" width="15" class="d-inline-block cursor-pointer" @click="changeQtyProduct('plus')">
                                        </div>
                                      </div>
                                      <div class="col-8">
                                        <button type="button" class="button-secondary w-100 text-truncate px-4 text-12" style="height: 47px" @click="addToCart">
                                          <pulse-loader :loading="push_loader" color="#fff" v-if="push_loader"></pulse-loader>
                                          <template v-else>
                                            {{qtyCart == 0 ? 'Add to cart' : counter == 0 ? $t('hotel.action.cancel-order') : $t('hotel.action.save-changes')}} <template v-if="counter > 0">- {{formatCurrency(total_price)}}</template>
                                          </template>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="position-relative z-index-1038" @click="done">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-bottom d-block nav-bottom" style="bottom:0%">
          <div class="custom-container-fluid px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-12 position-relative">
                <div class="">
                  <div class="w-100 py-2 px-2" 
                    @click="is_cart_double = false"
                    style="height: 100vh;background-color: #00000099">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {formatCurrency,calculateFinalPriceConcierge} from '@/utils/index.js'
  import {mapGetters,mapMutations} from 'vuex';

  export default{
    props: ['data'],
    data(){
      return{
        variant_selected: {},
        counter: 1,
        push_loader: false
      }
    },
    computed:{
      total_price(){
        let price = calculateFinalPriceConcierge(this.variant_selected.price)
        return parseInt(this.counter) * parseInt(price)
      },
      qtyCart(){
        let data = 0
        let record = this.getConciergeOrder().cart.findIndex(x=>x.product.data.product_id == this.data.product_id)
        if(record != -1){
          let record_variant = this.getConciergeOrder().cart[record].variant.findIndex(x=>x.data.product_ga_pos_id == this.variant_selected.product_ga_pos_id)
          if(record_variant != -1){
            data = this.getConciergeOrder().cart[record].variant[record_variant].qty
          }
        }

        return data
      }
    },
    watch:{
      variant_selected:{
        deep: true,
        handler(){
          this.counter = this.qtyCart == 0 ? 1 : this.qtyCart
        }
      }
    },
    created(){
      this.variant_selected = this.data.variant_list[0]
      this.counter = this.qtyCart
    },
    methods:{
      ...mapGetters(['getConciergeOrder']),
      ...mapMutations(['setConciergeOrder','removeConciergeOrder']),
      formatCurrency(value){
        return formatCurrency(value);
      },
      done(){
        this.$emit('done',false)
      },
      is_decrease_promo(price){
        if(price.promotion_amount == 0){
          return false
        }else{
          return price.promotion_type == 'INCREASE' ? false : true
        }
      },  
      final_price(price){
        return calculateFinalPriceConcierge(price)
      },
      promotion_price(price){
        if(price.promotion_amount == 0){
          return 0
        }else{
          return price.tax_service_calculation_type == 'INCLUDE' ? price.price_sell_base : price.price_sell
        }
      },
      changeQtyProduct(type){
        if(!this.push_loader){
          if(type == 'minus'){
            let comparison = this.qtyCart == 0 ? 1 : 0

            if(this.counter > comparison){
              this.counter--
            }
          }else{
            this.counter++
          }
        }
      },
      addToCart(){
        if(!this.push_loader){
          this.push_loader = true
          let data = {
            product: this.data,
            variant: this.variant_selected,
            qty: this.counter
          }
          if(this.counter == 0){
            this.removeConciergeOrder(data)
          }else{
            this.setConciergeOrder(data)
          }
          setTimeout(()=>{
            this.push_loader = false
            this.done()
          },1000)
        }
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/general/menuVariantDetail.vue